var map = {
	"./AnnouncementsWidget.vue": 9992,
	"./GrowthUpsellBox.vue": 14982,
	"./ProUpsellBox.vue": 3296,
	"./ResourcesWidget.vue": 79519,
	"./StatsWidget.vue": 83390,
	"./TemplateSelectWidget.vue": 2274,
	"./TopCampaignsWidget.vue": 72127,
	"./UpsellBox.vue": 44450,
	"./UpsellWidget.vue": 47169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70356;